import { createSlice } from "@reduxjs/toolkit";

export const comPaysSlice = createSlice(
    {
    name : "ComPays",
    initialState: {
        codepays: "BJ",
        labelbouton: "Valider",
        labelbouton2: "Ecouter"
    },
    reducers: {
        // action : {type: '', payload : tout ce qu'on veut}
        sendCodePays : (state, action) => {
            state.codepays = action.payload
        }       

    }
})